import React, {useState, useEffect} from 'react'

import { 
    Layout,
    Col, 
    Row,
    Button,
    Select,
    Input,
    Space,
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import BtnExcel from '../../Components/BtnExcel';
import { getTodayDateISO, formatAmount } from '../../Utils/Common';

const { Search } = Input;

const MonthlyPayment = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [excelData, setExcelData] = useState([])
  const [totalAmount, setTotalAmount] = useState(0);
  const [receivableData, setReceivableData] = useState([])
  const [filterConfig, setFilterConfig] = useState({
    type: '',
    search: '',
    page: 1,
  })

  async function fetchReceivableData() {
    setIsLoading(true);
    const response = await UseGetRequest("tenants/receivables_report", filterConfig);
    if (response.data) {
      const data = response?.data?.data?.map((data) => ({
        tenant_name: data.tenant_name,
        current: data.current && formatAmount(data.current),
        one_to_thirty: data.one_to_thirty && formatAmount(data.one_to_thirty),
        thirtyone_to_sixty: data.thirtyone_to_sixty && formatAmount(data.thirtyone_to_sixty),
        sixtyone_to_ninety: data.sixtyone_to_ninety && formatAmount(data.sixtyone_to_ninety),
        above_ninety: data.above_ninety && formatAmount(data.above_ninety),
        total: data.total && formatAmount(data.total),
      }))

      setTotalAmount(response?.data?.total)
      setPageSize(response?.data?.size)
      setReceivableData(data);
    } else {
      setTotalAmount(0)
      setPageSize('')
      setReceivableData([])
    }
    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true);
    const response = await UseGetRequest("tenants/receivables_report", 
      {
        type: filterConfig.type,
        search: filterConfig.search,
      }
    );
    if (response.data) {
      const data = response?.data?.data?.map((data) => ({
        tenant_name: data.tenant_name,
        current: data.current && formatAmount(data.current),
        one_to_thirty: data.one_to_thirty && formatAmount(data.one_to_thirty),
        thirtyone_to_sixty: data.thirtyone_to_sixty && formatAmount(data.thirtyone_to_sixty),
        sixtyone_to_ninety: data.sixtyone_to_ninety && formatAmount(data.sixtyone_to_ninety),
        above_ninety: data.above_ninety && formatAmount(data.above_ninety),
        total: data.total && formatAmount(data.total),
      }))

      setExcelData(data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  function ActionBtn(row) {
    return (
      <span className='center'>
        <Button className='button-color btn-header' type="primary">Print</Button>
      </span>
    );
  }

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const onSearchType = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        type: e || '',
        page: 1,
      }
    ));
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize,
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchReceivableData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'receivable_report_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={12} className='header-container'>
            OPEN BILLS
          </Col>
          <Col span={12} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "Tradename",
                  "Current",
                  "1 - 30",
                  "30 - 60",
                  "60 - 90",
                  "Above 90",
                  "Total",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Open_Bill_${getTodayDateISO()}.xlsx`}
              />
            </Space>
          </Col>
        </Row>
        <Row className='ms-4'>
          <Space lassName='responsive-inline excel-row'>
            <Search
              placeholder="Search..."
              size='medium'
              onSearch={(e)=>handleSearchChange(e)}
              onChange={(e)=>handleEmpty(e)}
              className='responsive-header-input'
            />    
            <Select
              placeholder="Select Type"
              onChange={(e)=>onSearchType(e)}
              placement='bottomLeft'
              className='select-field responsive-header-input'
              align='left'
              options={[
                {
                  value: '',
                  label: 'All',
                },
                {
                  value: 'tenant',
                  label: 'Tenant',
                },
                {
                  value: 'owner',
                  label: 'Owner',
                },
              ]}
            />       
          </Space>
        </Row>
        <Row gutter={[16, 16]} className='me-4'>
          <Col span={12}>
          
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className='amount-total' align='right'>
            Total Amount: {formatAmount(totalAmount)}
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24}>
            <AntDTable
              tableHeaders={[
                "Tenant/Owner Name",
                "Current",
                "1-30",
                "31-60",
                "61-90",
                "Above 90",
                "Total",
              ]}
              headerSelector={[
                "tenant_name",
                "current",
                "one_to_thirty",
                "thirtyone_to_sixty",
                "sixtyone_to_ninety",
                "above_ninety",
                "total",
              ]}
                tableData={receivableData}
                withAction={false}
                ActionBtn={(row) => ActionBtn(row)}
                loading={isLoading}
                tablePages={10}
                handleTableChange={handleTableChange}
                filterConfig={filterConfig}
                totalSize={pageSize}
                isSearch={true}
              />
            </Col>
          </Row>
        </Layout>
    </Layout>
  )
}

export default MonthlyPayment
